import { Grid, Typography } from '@mui/material';
import { StandardDialog } from '../../../shared/components/dialogs/StandardDialog';
import { StandardTopbarTitle } from '../../../shared/components/skeleton/TopBar';
import { LocalizedStrict } from '../../localization/components/AppLocalized';
import { MerchantNewsArticle } from '../../merchant/admin/merchantNewsItemType';
import { makeStyles } from 'tss-react/mui';

import { StandardButton } from '../../../shared/components/buttons/StandardButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleX } from '@fortawesome/pro-light-svg-icons';
import { useApiMutation } from '../../../core/api/useApiMutation';
import { DeleteMerchantAdminNews } from '../../merchant/admin/merchantAdminNewsApi';
import { useAppSelector } from '../../store/storeHooks';
import { selectUserCompanyId } from '../../login/loginSelectors';


type DeleteNewsModalProps = Readonly<{
    article: MerchantNewsArticle,
    open: boolean
    onClose: () => void
}>



const useStyles = makeStyles()((theme) => ({

    container: {
        paddingBottom: theme.spacing(16),
        marginTop: "-1rem",

    },


    card: {
        position: "relative",
        width: "50%", // set according to gap %
        border: 'none',
        [theme.breakpoints.down(1000)]: {
            width: "50%", // set according to gap %
        },

        [theme.breakpoints.down("sm")]: {
            width: "50%",
        },
    },

    chip: {
        padding: '0.1rem',
        borderRadius: 0,
        position: "absolute",
        top: 0,
        right: 0,
    }
}))



export function DeleteNewsModal({ article, open, onClose }: DeleteNewsModalProps) {

    const { classes, cx } = useStyles()

    const companyId = useAppSelector(selectUserCompanyId)
    const { mutateAsync: CallDeleteMerchantAdminNews } = useApiMutation(DeleteMerchantAdminNews, {})

    function handleDeleteClick() {
        if (!companyId) {
            return;
        } else {
            CallDeleteMerchantAdminNews({
                merchantId: companyId,
                articleId: article.id
            })
            onClose();
        }
    }

    return (
        <StandardDialog
            // titleElement={(
            //     <LocalizedStrict id="delete-news-modal-title">
            //         <StandardTopbarTitle>Delete</StandardTopbarTitle>
            //     </LocalizedStrict>

            // )}
            open={open}
            onClose={onClose}
        >

            <Grid container justifyContent="center" alignItems="center" direction="column" wrap="nowrap" className={classes.container}>

                <FontAwesomeIcon icon={faCircleX} size='5x' style={{ color: "#ff1a1a", }} />

                <LocalizedStrict id="delete-news-modal-confirm-label">
                    <Typography color="GrayText" variant='h5' sx={{ marginBottom: "2rem", marginTop: "1.5rem" }}>
                        Are you sure you want to delete:
                    </Typography>
                </LocalizedStrict>

                <Grid item alignContent="center" textAlign="center" paddingX="1rem">
                    <Typography variant='body1' sx={{ marginTop: "1.5rem" }}>
                        "{article.subject}"
                    </Typography>
                </Grid>


                <Grid container direction="row" wrap='nowrap' gap={2} marginTop="9rem" marginBottom="-4rem">
                    <LocalizedStrict id="delete-news-modal-button-delete-label">
                        <StandardButton sx={{ marginLeft: "2rem" }} color='error' onClick={handleDeleteClick}>Delete</StandardButton>
                    </LocalizedStrict>

                    <LocalizedStrict id="delete-news-modal-button-cancel-label">
                        <StandardButton sx={{ marginRight: "2rem" }} color='black' onClick={onClose}>Cancel</StandardButton>
                    </LocalizedStrict>
                </Grid>

            </Grid>
        </StandardDialog>
    )
}
